import React, { useState } from 'react';
import NavBar from '../navigationBar';
import NumberInput from '../components/numberInput';
import { IconButton, Box, Button, Typography } from '@mui/material/';
import BSOE_Buttons from '../components/bsoeFloorButtons.js';
import BSOE_Buttons_Mobile_View from '../components/bsoeFloorButtonsMobileView.js'
import BSOEShowImage from '../components/bsoeSearchFloor.js';
import { uds } from '../services/userservices';
import { auth } from '../firebase';
import { BrowserView, MobileView } from 'react-device-detect';
import MobileNavBar from '../mobileNavigationBar';


function BSOE() {
    const [buttonsVisible, setButtonsVisible] = useState(true);
    const [show, setShow] = useState(false);
    const [content, setContent] = useState('');
    const [arrayLength, setArrayLength] = useState('');
    const building = 'Baskin_Engineering_1';
    
    const handleButtonClick = ({ content, arrayLength }) => {
        setContent(content);
        setButtonsVisible(false);
        setShow(true);
        setArrayLength(arrayLength);
    };

    const handleReset = () => {
        console.log("reset");
        setButtonsVisible(true);
        setShow(false);
        setContent('');
        setArrayLength('');
    };

    // [[seconds], [directions], [first coord], [last coord]]
    var seconds = []
    var directions = []
    var firstCoord = []
    var lastCoord = []
    let marginCorrect = 0;
    const marginTopSingle = -49;
    const marginTopDouble = -35;

    if (arrayLength === 3) {
        seconds = content[0].slice()
        directions = content[1].slice()
        firstCoord = content[2].slice()
        marginCorrect = marginTopSingle
    }
    else if (arrayLength === 4) {
        seconds = content[0].slice()
        directions = content[1].slice()
        firstCoord = content[2].slice()
        lastCoord = content[3].slice()
        marginCorrect = marginTopDouble
    }

    const minute = Math.floor(seconds[0] / 60);
    const second = seconds[0] - (minute * 60);

    return (
        <>
            <BrowserView>
                <NavBar />
                <Typography variant="h3" component="h2" m={2}>
                    Jack Baskin Engineering
                </Typography>
                <NumberInput onButtonClick={handleButtonClick} building={building} />
                <Box marginLeft={16} marginTop={-4.55}>
                    <Button variant="contained" color="primary" onClick={handleReset} m={2}>
                        Reset
                    </Button>
                </Box>
                {buttonsVisible && <BSOE_Buttons />}
                {show && <BSOEShowImage firstCoord={firstCoord} lastCoord={lastCoord} />}
                {directions.length > 0 && (
                    <div>
                        <Typography variant="h6" component="p" marginLeft={2} marginTop={marginCorrect}>
                            Directions:
                        </Typography>
                        <ul>
                            {directions.map((direction, index) => (
                                <li key={index}>{direction}</li>
                            ))}
                        </ul>
                        <Typography variant="h6" component="p" marginLeft={1} marginTop={1}>
                            <p>Estimated time: {minute} min {second} sec</p>
                        </Typography>
                    </div>
                )}
            </BrowserView>
            <MobileView>
                <Typography variant="h3" component="h2" m={2}>
                    Jack Baskin Engineering
                </Typography>

                {buttonsVisible && <BSOE_Buttons_Mobile_View />}

                {show && <BSOEShowImage firstCoord={firstCoord} lastCoord={lastCoord} />}

                {directions.length > 0 && (
                    <div>
                        <Typography variant="h6" component="p" marginLeft={2} marginTop={1}>
                            Directions:
                        </Typography>
                        <ul>
                            {directions.map((direction, index) => (
                                <li key={index}>{direction}</li>
                            ))}
                        </ul>
                        <Typography variant="h6" component="p" marginLeft={1} marginTop={1}>
                            <p>Estimated time: {minute} min {second} sec</p>
                        </Typography>
                    </div>
                )}

                <NumberInput onButtonClick={handleButtonClick} building={building} />
                <Box marginLeft={16} marginTop={-4.55} marginBottom={3}>
                    <Button variant="contained" color="primary" onClick={handleReset} m={2}>
                        Reset
                    </Button>
                </Box>

                <MobileNavBar />
            </MobileView>
        </>
    );
}

export default BSOE;